module.exports = "https://static.wmbcdn.com/uniweb/images/25d319f48f66aecd9dc2ed743e7066a1.svg";